// assets/why-choose-us.js
document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('[data-why-card]');
  if (cards.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.2
    }
  );

  cards.forEach((card, index) => {
    // Smooth stagger: each card starts 0.18s after the previous one
    card.style.transitionDelay = `${index * 0.18}s`;
    observer.observe(card);
  });
});